export const createCloseFullscreenIcon = () => {
  const closeFullscreenIcon = document.createElement('div');
  closeFullscreenIcon.className = 'cloudimage-360-close-fullscreen-icon';

  return closeFullscreenIcon;
};
